import { ReactComponent as LoadingCircleIcon } from "assets/images/iconsV2/loading-circle.svg";

export function DownloadAttachmentsSpinner() {
  return (
    <LoadingCircleIcon
      width={20}
      height={20}
      className="shipment-details-sheet__download-attachments-spinner"
      aria-hidden="true"
    />
  );
}
